import {
  AerometrexMd,
  CameraMd,
  FloorplanMd,
  Inline,
  paletteHelper,
  Text,
} from '@property.com.au/ui-kit';
import { FunctionComponent } from 'react';
import styled from 'styled-components';

type MediaCountIconName = 'AerometrexMd' | 'CameraMd' | 'FloorplanMd';

const mapIcons = {
  FloorplanMd: FloorplanMd,
  CameraMd: CameraMd,
  AerometrexMd: AerometrexMd,
};

const MediaCountsIcon: FunctionComponent<{
  iconName: MediaCountIconName;
  title: string;
}> = ({ iconName, title }) => {
  const MappedIcon = mapIcons[iconName];
  return <MappedIcon title={title} id={`${title}-icon`} />;
};

const MediaCountContainer = styled(Inline)`
  color: ${paletteHelper('textSecondary')};
`;

export interface MediaCount {
  iconName: MediaCountIconName;
  title: string;
  value: string;
}

interface PropertyTimelineMediaCountsProps {
  counts: MediaCount[];
}

export const PropertyTimelineMediaCounts: FunctionComponent<PropertyTimelineMediaCountsProps> = ({
  counts,
}) => {
  return (
    <Inline grow={false} gap="extraSmall">
      {counts.map(({ iconName, title, value }) => (
        <MediaCountContainer key={title} grow={false} gap="twoExtraSmall" title={title}>
          <MediaCountsIcon iconName={iconName} title={title} />
          <Text variant="body02">{value}</Text>
        </MediaCountContainer>
      ))}
    </Inline>
  );
};
